module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-main-image-ba8f2454a490f94a166344a1387912e1.png";